// Russian declension of the noun "сайт" so it agrees with the preceding count.
// Shared between the deactivate and verify dialogs (reuse-before-create): the
// same count/noun agreement is needed on both sides.
export function getSitesWord(count: number): string {
  let sitesWord: string;
  const lastTwo = count % 100;
  const lastOne = count % 10;
  if (lastTwo >= 11 && lastTwo <= 19) {
    sitesWord = "сайтов";
  } else {
    if (lastOne === 1) {
      sitesWord = "сайт";
    } else {
      if (lastOne >= 2 && lastOne <= 4) {
        sitesWord = "сайта";
      } else {
        sitesWord = "сайтов";
      }
    }
  }
  return sitesWord;
}
